import Axios from "axios";

export default function getCompany(
  id,
  setCompanies,
  setPaginationResult,
  page = 0,
  search = ""
) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/get-companies`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        service: id,
        admin: "true",
        page,
        search,
      },
    })
      .then((response) => {
        setCompanies(response.data.data);
        setPaginationResult(response?.data?.pagination);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
      });
  };
}
